function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg071Greece(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353.357 353.357",
    style: {
      enableBackground: "new 0 0 353.357 353.357"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#F0F0F0"
    },
    width: 353.357,
    height: 353.357
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#338AF3"
    },
    width: 353.357,
    height: 44.17
  }), /*#__PURE__*/React.createElement("rect", {
    y: 88.341,
    style: {
      fill: "#338AF3"
    },
    width: 353.357,
    height: 44.17
  }), /*#__PURE__*/React.createElement("rect", {
    y: 265.016,
    style: {
      fill: "#338AF3"
    },
    width: 353.357,
    height: 44.17
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#338AF3"
    },
    width: 195.881,
    height: 198.757
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 68.709,
    style: {
      fill: "#F0F0F0"
    },
    width: 195.881,
    height: 39.263
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.31,
    y: 0,
    style: {
      fill: "#F0F0F0"
    },
    width: 39.263,
    height: 183.596
  })), /*#__PURE__*/React.createElement("rect", {
    y: 176.681,
    style: {
      fill: "#338AF3"
    },
    width: 353.357,
    height: 44.17
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg071Greece);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDM1My4zNTcgMzUzLjM1NyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzUzLjM1NyAzNTMuMzU3OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxyZWN0IHk9IjAiIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiB3aWR0aD0iMzUzLjM1NyIgaGVpZ2h0PSIzNTMuMzU3Ii8+CjxnPgoJPHJlY3QgeT0iMCIgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSIzNTMuMzU3IiBoZWlnaHQ9IjQ0LjE3Ii8+Cgk8cmVjdCB5PSI4OC4zNDEiIHN0eWxlPSJmaWxsOiMzMzhBRjM7IiB3aWR0aD0iMzUzLjM1NyIgaGVpZ2h0PSI0NC4xNyIvPgoJPHJlY3QgeT0iMjY1LjAxNiIgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSIzNTMuMzU3IiBoZWlnaHQ9IjQ0LjE3Ii8+Cgk8cmVjdCB5PSIwIiBzdHlsZT0iZmlsbDojMzM4QUYzOyIgd2lkdGg9IjE5NS44ODEiIGhlaWdodD0iMTk4Ljc1NyIvPgo8L2c+CjxnPgoJPHJlY3QgeT0iNjguNzA5IiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgd2lkdGg9IjE5NS44ODEiIGhlaWdodD0iMzkuMjYzIi8+Cgk8cmVjdCB4PSI3OC4zMSIgeT0iMCIgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSIzOS4yNjMiIGhlaWdodD0iMTgzLjU5NiIvPgo8L2c+CjxyZWN0IHk9IjE3Ni42ODEiIHN0eWxlPSJmaWxsOiMzMzhBRjM7IiB3aWR0aD0iMzUzLjM1NyIgaGVpZ2h0PSI0NC4xNyIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };